import styled from 'styled-components'

import { TOP_NAV_BGCOLOR, SELECTED_ITEM_BG_COLOR } from '@CSSVars/colors'


export const _Pagination = styled.ul`
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
`

export const _PaginationItem = styled.li`
  display: flex;
  align-items: center;
  list-style: none;
  background-color: white;
  margin: 5px;
  width: 30px;
  height: 30px;
  border: 1px solid ${TOP_NAV_BGCOLOR};
  border-radius: 10px;
  span {
    padding: 10px 0;
    display: inline-block;
    line-height: 10px;
    width: 100%;
    height: auto;
    text-align: center;
  }

  a {
    padding: 10px 0;
    display: inline-block;
    vertical-align: middle;
    line-height: 10px;
    width: 100%;
    height: auto;
    color: ${({ isActive }) => (isActive ? 'white' : TOP_NAV_BGCOLOR)};
    background-color: ${({ isActive }) => (isActive ? TOP_NAV_BGCOLOR : 'transparent')};
    text-decoration: none;
    transition: background-color 0.3s;
    text-align: center;
    &:active {
      background-color: ${SELECTED_ITEM_BG_COLOR} !important;
    }
    border-radius: 10px;
  }
  @media (hover:hover) {
    a {
      &:hover {
        background-color: ${TOP_NAV_BGCOLOR};
        color: white;
      }
    }
  }
`
